import { AccountEnrollment, AccountType, Address, EnrollmentContact } from 'eve-account-client';
import { MarketingChannel } from '../../../components/Enrollment/CompanyInformation/MarketingChannel';
import EVerifyUser from '../../../components/Enrollment/EVerifyUsers/data/EVerifyUser';
import { EnrollmentData } from '../EnrollmentData';

const toAccountEnrollment = (
  enrollmentData: Omit<EnrollmentData, 'accessMethodFormData'>,
  accountType: AccountType,
  webAccessEnabled: boolean,
): AccountEnrollment => {
  if (!enrollmentData?.companyAddressesFormData || !enrollmentData?.companyInformationFormData) {
    throw new Error('enrollmentData is missing required information.');
  }

  const getMailingAddress = (): Address | undefined => {
    return enrollmentData.companyAddressesFormData?.mailingAddressIsSame
      ? undefined
      : enrollmentData.companyAddressesFormData?.mailingAddress;
  };

  const getMarketingChannel = (): MarketingChannel | undefined => {
    return enrollmentData.marketingChannel?.primaryValue ? enrollmentData.marketingChannel : undefined;
  };

  const getEnrollmentContacts = (): EnrollmentContact[] | undefined => {
    if (!enrollmentData.everifyUserFormData) {
      return undefined;
    }

    const isMouSignatory = (user: EVerifyUser): boolean => {
      if (accountType === AccountType.CLIENT) {
        return true;
      }
      return user.mouSignatory === 'Yes';
    };

    const isAdmin = (user: EVerifyUser): boolean => {
      if (accountType === AccountType.CLIENT) {
        return false;
      }
      return user.admin === 'Yes';
    };

    return enrollmentData.everifyUserFormData.map(
      (user): EnrollmentContact => ({
        firstName: user.firstName,
        middleInitial: user.middleInitial,
        lastName: user.lastName,
        email: user.emailAddress,
        phoneNumber: {
          number: user.phoneNumber,
          extension: user.phoneNumberExtension,
        },
        mouSignatory: isMouSignatory(user),
        admin: isAdmin(user),
      }),
    );
  };

  return {
    companyInfo: {
      companyName: enrollmentData.companyInformationFormData.companyName,
      dba: enrollmentData.companyInformationFormData.dba,
      dunsNumber: enrollmentData.companyInformationFormData.dunsNumber,
      employerCategory: enrollmentData.employerCategoryFormData,
      employerIdNumber: enrollmentData.companyInformationFormData.employerIdNumber,
      employeeRangeId: enrollmentData.companyInformationFormData.employeeRangeId,
      mailingAddress: getMailingAddress(),
      naicsCode: enrollmentData.companyInformationFormData.naicsCode,
      physicalLocation: enrollmentData.companyAddressesFormData.physicalLocation,
      ueiSAM: enrollmentData.companyInformationFormData.ueiSAM,
    },
    marketingChannel: getMarketingChannel(),
    contacts: getEnrollmentContacts(),
    hiringSites: enrollmentData.hiringSitesFormData,
    type: accountType,
    webServiceAccess: {
      enabled: webAccessEnabled,
    },
  };
};

export default toAccountEnrollment;
